import {
  FormControlLabel,
  FormGroupProps,
  Radio,
  RadioGroup,
} from '@mui/material';
import {
  Control,
  Controller,
  FieldValues,
  Path,
  RegisterOptions,
} from 'react-hook-form';

import { getDataTestId } from '@/utils/browser';

export type RadioOption = {
  value: string | number | boolean;
  label: string | React.ReactNode;
};

type RadioToggleProps<FormPayload extends FieldValues> = {
  control: Control<FormPayload>;
  name: Path<FormPayload>;
  options: RadioOption[];
  rules?: Omit<
    RegisterOptions<FormPayload, Path<FormPayload>>,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
  >;
  sx?: FormGroupProps['sx'];
};

export function RadioToggle<FormPayload extends FieldValues>({
  name,
  control,
  options,
  rules,
  sx,
}: RadioToggleProps<FormPayload>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <RadioGroup row {...field} sx={sx}>
          {options.map(opt => (
            <FormControlLabel
              key={String(opt.value)}
              value={opt.value}
              control={<Radio />}
              label={opt.label}
              {...getDataTestId(`${name}-radio-option-${opt.value}`)}
            />
          ))}
        </RadioGroup>
      )}
    />
  );
}
